var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 53,
    viewBox: "0 0 200 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.19635 28.1416C-0.398786 27.219 -0.398783 24.9123 1.19635 23.9897L16.3921 15.2001C17.9872 14.2775 19.9811 15.4308 19.9811 17.2761V34.8552C19.9811 36.7005 17.9872 37.8538 16.3921 36.9312L1.19635 28.1416Z",
    fill: "url(#paint0_linear_40_267)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.0837 50.002C46.0865 51.8473 44.0944 53.0037 42.4978 52.0835L27.2887 43.3173C25.6922 42.3971 25.6886 40.0904 27.2824 39.1653L42.4646 30.3525C44.0583 29.4274 46.054 30.5776 46.0568 32.423L46.0837 50.002Z",
    fill: "url(#paint1_linear_40_267)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4169 17.3608C22.4141 15.5155 24.4063 14.3591 26.0028 15.2793L41.212 24.0455C42.8085 24.9657 42.812 27.2723 41.2183 28.1975L26.0361 37.0103C24.4423 37.9354 22.4467 36.7852 22.4438 34.9398L22.4169 17.3608Z",
    fill: "url(#paint2_linear_40_267)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4498 0.324733C44.0449 -0.59793 46.0388 0.555401 46.0388 2.40073V19.9798C46.0388 21.8251 44.0449 22.9785 42.4498 22.0558L27.2541 13.2663C25.6589 12.3436 25.6589 10.0369 27.2541 9.11427L42.4498 0.324733Z",
    fill: "url(#paint3_linear_40_267)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M55.0742 39.3254V19.6463H62.1316V39.3254H55.0742ZM58.6029 17.5964C57.6483 17.5964 56.83 17.2804 56.1482 16.6483C55.4663 16.0163 55.1254 15.2561 55.1254 14.3678C55.1254 13.4795 55.4663 12.7193 56.1482 12.0873C56.83 11.4552 57.6483 11.1392 58.6029 11.1392C59.5661 11.1392 60.3843 11.4552 61.0577 12.0873C61.7395 12.7193 62.0805 13.4795 62.0805 14.3678C62.0805 15.2561 61.7395 16.0163 61.0577 16.6483C60.3843 17.2804 59.5661 17.5964 58.6029 17.5964Z",
    fill: "url(#paint4_linear_40_267)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M65.7274 39.3254V19.6463H72.4268V23.3874H72.6314C73.0405 22.1575 73.7394 21.1837 74.7281 20.4663C75.7169 19.7488 76.8931 19.3901 78.2569 19.3901C79.6376 19.3901 80.8267 19.7574 81.8239 20.4919C82.8211 21.2179 83.422 22.1831 83.6266 23.3874H83.8312C84.1636 22.1831 84.871 21.2179 85.9535 20.4919C87.036 19.7574 88.306 19.3901 89.7635 19.3901C91.6471 19.3901 93.1728 19.9965 94.3405 21.2094C95.5168 22.4222 96.1049 24.0365 96.1049 26.0523V39.3254H89.0475V27.846C89.0475 26.9833 88.8301 26.3085 88.3955 25.8217C87.9608 25.3263 87.3769 25.0786 86.6439 25.0786C85.9194 25.0786 85.3441 25.3263 84.9179 25.8217C84.5003 26.3085 84.2914 26.9833 84.2914 27.846V39.3254H77.5409V27.846C77.5409 26.9833 77.3235 26.3085 76.8888 25.8217C76.4541 25.3263 75.8703 25.0786 75.1373 25.0786C74.6514 25.0786 74.2338 25.1896 73.8843 25.4117C73.5349 25.6338 73.2621 25.9541 73.0661 26.3726C72.8786 26.7826 72.7848 27.2737 72.7848 27.846V39.3254H65.7274Z",
    fill: "url(#paint5_linear_40_267)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M105.058 39.6329C103.805 39.6329 102.697 39.4279 101.734 39.018C100.779 38.5994 100.029 37.9674 99.4834 37.1218C98.9379 36.2762 98.6651 35.2 98.6651 33.8932C98.6651 32.817 98.8484 31.8988 99.2149 31.1386C99.5814 30.3699 100.093 29.7421 100.749 29.2553C101.405 28.7684 102.168 28.3969 103.038 28.1406C103.916 27.8844 104.862 27.7178 105.876 27.641C106.975 27.5555 107.858 27.4531 108.522 27.3335C109.196 27.2054 109.682 27.0303 109.98 26.8082C110.278 26.5776 110.427 26.2744 110.427 25.8985V25.8473C110.427 25.3348 110.231 24.9419 109.839 24.6686C109.447 24.3953 108.944 24.2586 108.331 24.2586C107.657 24.2586 107.108 24.4081 106.681 24.707C106.264 24.9974 106.012 25.4459 105.927 26.0523H99.4322C99.5174 24.8565 99.8967 23.7547 100.57 22.7468C101.252 21.7304 102.245 20.919 103.549 20.3125C104.853 19.6976 106.481 19.3901 108.433 19.3901C109.839 19.3901 111.101 19.5566 112.217 19.8897C113.334 20.2143 114.284 20.6713 115.068 21.2606C115.853 21.8414 116.449 22.5247 116.858 23.3105C117.276 24.0878 117.485 24.9334 117.485 25.8473V39.3254H110.888V36.5581H110.734C110.342 37.2926 109.865 37.8862 109.302 38.3389C108.748 38.7916 108.113 39.1204 107.397 39.3254C106.69 39.5304 105.91 39.6329 105.058 39.6329ZM107.359 35.1744C107.896 35.1744 108.399 35.0633 108.868 34.8413C109.345 34.6192 109.733 34.2989 110.031 33.8804C110.329 33.4618 110.479 32.9536 110.479 32.3557V30.7158C110.291 30.7927 110.091 30.8653 109.878 30.9336C109.673 31.002 109.451 31.066 109.213 31.1258C108.983 31.1856 108.736 31.2411 108.471 31.2924C108.216 31.3436 107.947 31.3906 107.666 31.4333C107.12 31.5187 106.673 31.6596 106.323 31.8561C105.982 32.044 105.727 32.2789 105.556 32.5607C105.394 32.8341 105.313 33.1415 105.313 33.4832C105.313 34.0298 105.505 34.4484 105.889 34.7388C106.272 35.0292 106.762 35.1744 107.359 35.1744Z",
    fill: "url(#paint6_linear_40_267)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M120.857 39.3254V19.6463H127.71V23.3874H127.914C128.272 22.0037 128.839 20.9916 129.615 20.351C130.399 19.7104 131.315 19.3901 132.363 19.3901C132.67 19.3901 132.973 19.4157 133.271 19.467C133.578 19.5097 133.872 19.5737 134.153 19.6591V25.6935C133.804 25.574 133.374 25.4843 132.862 25.4245C132.351 25.3647 131.912 25.3348 131.545 25.3348C130.855 25.3348 130.233 25.4928 129.679 25.8089C129.133 26.1163 128.703 26.5519 128.387 27.1157C128.072 27.6709 127.914 28.3243 127.914 29.0759V39.3254H120.857Z",
    fill: "url(#paint7_linear_40_267)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M136.468 39.3254V19.6463H143.525V39.3254H136.468ZM139.996 17.5964C139.042 17.5964 138.223 17.2804 137.541 16.6483C136.86 16.0163 136.519 15.2561 136.519 14.3678C136.519 13.4795 136.86 12.7193 137.541 12.0873C138.223 11.4552 139.042 11.1392 139.996 11.1392C140.959 11.1392 141.778 11.4552 142.451 12.0873C143.133 12.7193 143.474 13.4795 143.474 14.3678C143.474 15.2561 143.133 16.0163 142.451 16.6483C141.778 17.2804 140.959 17.5964 139.996 17.5964Z",
    fill: "url(#paint8_linear_40_267)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M156.582 39.6842C154.451 39.6842 152.627 39.2614 151.11 38.4158C149.593 37.5617 148.429 36.3744 147.619 34.8541C146.81 33.3252 146.405 31.5529 146.405 29.5371C146.405 27.5214 146.81 25.7533 147.619 24.233C148.429 22.7041 149.593 21.5169 151.11 20.6713C152.627 19.8171 154.451 19.3901 156.582 19.3901C158.713 19.3901 160.537 19.8171 162.054 20.6713C163.571 21.5169 164.734 22.7041 165.544 24.233C166.354 25.7533 166.759 27.5214 166.759 29.5371C166.759 31.5529 166.354 33.3252 165.544 34.8541C164.734 36.3744 163.571 37.5617 162.054 38.4158C160.537 39.2614 158.713 39.6842 156.582 39.6842ZM156.633 34.4569C157.229 34.4569 157.745 34.2562 158.18 33.8547C158.615 33.4533 158.951 32.881 159.19 32.1379C159.429 31.3949 159.548 30.5108 159.548 29.4859C159.548 28.4524 159.429 27.5684 159.19 26.8338C158.951 26.0907 158.615 25.5185 158.18 25.117C157.745 24.7156 157.229 24.5148 156.633 24.5148C156.002 24.5148 155.461 24.7156 155.009 25.117C154.557 25.5185 154.212 26.0907 153.974 26.8338C153.735 27.5684 153.616 28.4524 153.616 29.4859C153.616 30.5108 153.735 31.3949 153.974 32.1379C154.212 32.881 154.557 33.4533 155.009 33.8547C155.461 34.2562 156.002 34.4569 156.633 34.4569Z",
    fill: "url(#paint9_linear_40_267)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M169.623 39.3254V19.6463H176.322V23.3874H176.527C176.936 22.1575 177.635 21.1837 178.623 20.4663C179.612 19.7488 180.788 19.3901 182.152 19.3901C183.533 19.3901 184.722 19.7574 185.719 20.4919C186.716 21.2179 187.317 22.1831 187.522 23.3874H187.726C188.059 22.1831 188.766 21.2179 189.849 20.4919C190.931 19.7574 192.201 19.3901 193.659 19.3901C195.542 19.3901 197.068 19.9965 198.236 21.2094C199.412 22.4222 200 24.0365 200 26.0523V39.3254H192.943V27.846C192.943 26.9833 192.725 26.3085 192.291 25.8217C191.856 25.3263 191.272 25.0786 190.539 25.0786C189.814 25.0786 189.239 25.3263 188.813 25.8217C188.395 26.3085 188.187 26.9833 188.187 27.846V39.3254H181.436V27.846C181.436 26.9833 181.219 26.3085 180.784 25.8217C180.349 25.3263 179.765 25.0786 179.032 25.0786C178.547 25.0786 178.129 25.1896 177.779 25.4117C177.43 25.6338 177.157 25.9541 176.961 26.3726C176.774 26.7826 176.68 27.2737 176.68 27.846V39.3254H169.623Z",
    fill: "url(#paint10_linear_40_267)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_40_267",
    x1: 3.72529e-7,
    y1: 26.2032,
    x2: 200,
    y2: 26.2032,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#06B6D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF63C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_40_267",
    x1: 3.72529e-7,
    y1: 26.2032,
    x2: 200,
    y2: 26.2032,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#06B6D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF63C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_40_267",
    x1: 3.72529e-7,
    y1: 26.2032,
    x2: 200,
    y2: 26.2032,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#06B6D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF63C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_40_267",
    x1: 3.72529e-7,
    y1: 26.2032,
    x2: 200,
    y2: 26.2032,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#06B6D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF63C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_40_267",
    x1: 3.72529e-7,
    y1: 26.2032,
    x2: 200,
    y2: 26.2032,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#06B6D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF63C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_40_267",
    x1: 3.72529e-7,
    y1: 26.2032,
    x2: 200,
    y2: 26.2032,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#06B6D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF63C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_40_267",
    x1: 3.72529e-7,
    y1: 26.2032,
    x2: 200,
    y2: 26.2032,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#06B6D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF63C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_40_267",
    x1: 3.72529e-7,
    y1: 26.2032,
    x2: 200,
    y2: 26.2032,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#06B6D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF63C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_40_267",
    x1: 3.72529e-7,
    y1: 26.2032,
    x2: 200,
    y2: 26.2032,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#06B6D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF63C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_40_267",
    x1: 3.72529e-7,
    y1: 26.2032,
    x2: 200,
    y2: 26.2032,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#06B6D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF63C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_40_267",
    x1: 3.72529e-7,
    y1: 26.2032,
    x2: 200,
    y2: 26.2032,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#06B6D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF63C3"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.6dfc6799157006b7cd5e4f34d5a47771.svg";
export { ForwardRef as ReactComponent };